import { useState, useEffect, useCallback } from "react";
import Select, { ActionMeta } from "react-select";
import * as APIModels from "../../models";
import { DataService } from "../../services/DataService";

export default function CaseTypes() {
    type MyOptionType = { label: string; value: string };

    const [stateOptions, setStateOptions] = useState([] as MyOptionType[]);
    const [stateId, setStateId] = useState("");

    const [countyId, setCountyId] = useState("");
    const [countyOptions, setCountyOptions] = useState([] as MyOptionType[]);

    const [divisionId, setDivisionId] = useState("");
    const [divisionOptions, setDivisionOptions] = useState(
        [] as MyOptionType[]
    );

    const c: APIModels.CaseType[] = [];
    const [ePortalCaseTypes, setePortalCaseTypes] = useState(c);

    const cs: APIModels.CaseSubType[] = [];
    const [caseSubTypes, setCaseSubTypes] = useState(cs);

    useEffect(() => {
        DataService.getStates().then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.abbreviation!, label: v.name! };
                });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        DataService.getCountiesByPortal({ state: stateId! }).then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setCountyOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [stateId]);

    useEffect(() => {
        DataService.getDivisions({ countyId: countyId! }).then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setDivisionOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [countyId]);

    const onStateChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setStateId(value?.value ?? "");
    };

    const onCountyChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCountyId(value?.value ?? "");
    };

    const onDivisionChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setDivisionId(value?.value ?? "");
    };

    const onSearch = () => {
        DataService.getPortalCaseTypes({
            countyId: countyId!,
            divisionId: divisionId,
        }).then(
            (resp) => {
                setePortalCaseTypes(resp.data!);
                console.log("ePortal Case Types:");
                console.log(ePortalCaseTypes);
            },
            (error) => {
                console.log(error);
            }
        );

        DataService.getCaseSubTypesByDivision({
            divisionId: divisionId,
        }).then(
            (resp) => {
                //console.log("Success " + JSON.stringify(resp.data));
                setCaseSubTypes(
                    resp.filter((c) => c.active && c.active == true)
                );
                console.log("Case Types:");
                console.log(caseSubTypes);
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onSync = () => {
        DataService.syncCaseTypes({
            countyId: countyId!,
            divisionId: divisionId,
        })
            .then(
                (resp) => {
                    //console.log("Success " + JSON.stringify(resp.data));
                    //setePortalCaseTypes(resp.data! as APIModels.CaseType[]);
                    console.log("ePortal Case Types:");
                    console.log(ePortalCaseTypes);
                },
                (error) => {
                    console.log(error);
                }
            )
            .then(() => onSearch());

        //onSearch();
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Case Types</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Data</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Case Types
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="col-sm-6">
                    <div className="row">
                        <div className="col-sm-8">
                            <label htmlFor="selState" className="form-label">
                                State
                            </label>
                            <Select
                                id="selState"
                                name="selState"
                                className="required"
                                value={stateOptions.filter(
                                    (c) => c.value === stateId
                                )}
                                options={stateOptions}
                                onChange={onStateChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-sm-6">
                    <div className="row">
                        <div className="col-sm-8">
                            <label htmlFor="selCounty" className="form-label">
                                County
                            </label>
                            <Select
                                id="selCounty"
                                name="selCounty"
                                value={countyOptions.filter(
                                    (c) => c.value === countyId
                                )}
                                // filterOption={filterOption}
                                options={countyOptions}
                                onChange={onCountyChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-sm-6">
                    <div className="row">
                        <div className="col-sm-8">
                            <label htmlFor="selDivision" className="form-label">
                                Division
                            </label>
                            <Select
                                id="selDivision"
                                name="selDivision"
                                value={divisionOptions.filter(
                                    (c) => c.value === divisionId
                                )}
                                // filterOption={filterOption}
                                options={divisionOptions}
                                onChange={onDivisionChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 text-end">
                    <div className="row">
                        <div className="col-sm-8">
                            <button
                                className="btn btn-primary waves-effect waves-light mt-2"
                                type="button"
                                onClick={onSearch}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-18 text-center" style={{ margin: "20px" }}>
                <button
                    className="btn btn-success waves-effect waves-light mt-2"
                    type="button"
                    onClick={onSync}
                >
                    <i className="mdi mdi-arrow-left me-1"></i>
                    Sync
                </button>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="tablesaw-bar tablesaw-mode-stack">
                                    <table
                                        className="tablesaw table mb-0 tablesaw-stack text-center"
                                        data-tablesaw-mode="stack"
                                        id="table-saw-3859"
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    scope="col"
                                                    data-tablesaw-sortable-col=""
                                                    data-tablesaw-priority="4"
                                                >
                                                    eportalID
                                                </th>
                                                <th
                                                    scope="col"
                                                    data-tablesaw-sortable-col=""
                                                    data-tablesaw-sortable-default-col=""
                                                    data-tablesaw-priority="persist"
                                                >
                                                    Case Type Name
                                                </th>
                                                <th
                                                    scope="col"
                                                    data-tablesaw-sortable-col=""
                                                    data-tablesaw-priority="2"
                                                >
                                                    Code
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {caseSubTypes.length > 0 &&
                                                caseSubTypes.map((c, i) => {
                                                    return (
                                                        <tr>
                                                            <td>
                                                                {c.ePortalID}
                                                            </td>
                                                            <td>{c.name}</td>
                                                            <td>{c.code}</td>
                                                        </tr>
                                                    );
                                                })}
                                            <tr>
                                                <td>
                                                    <span className="tablesaw-cell-content"></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="tablesaw-bar tablesaw-mode-stack text-center">
                                    <table
                                        className="tablesaw table mb-0 tablesaw-stack"
                                        data-tablesaw-mode="stack"
                                        id="table-saw-3859"
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    scope="col"
                                                    data-tablesaw-sortable-col=""
                                                    data-tablesaw-priority="4"
                                                >
                                                    eportalID
                                                </th>
                                                <th
                                                    scope="col"
                                                    data-tablesaw-sortable-col=""
                                                    data-tablesaw-sortable-default-col=""
                                                    data-tablesaw-priority="persist"
                                                >
                                                    Case Type Name
                                                </th>
                                                <th
                                                    scope="col"
                                                    data-tablesaw-sortable-col=""
                                                    data-tablesaw-priority="2"
                                                >
                                                    Code
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ePortalCaseTypes.length > 0 &&
                                                ePortalCaseTypes.map((p, i) => {
                                                    return (
                                                        <tr>
                                                            <td>
                                                                {p.ePortalID}
                                                            </td>
                                                            <td>
                                                                {p.description}
                                                            </td>
                                                            <td>
                                                                {p.caseTypeCode}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            <tr>
                                                <td>
                                                    <span className="tablesaw-cell-content"></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
